module.exports = __webpack_public_path__ + "media/justPickedThatOut.42df47ef.mp3";